import { Outlet } from "react-router-dom";

const StaffManagementMainPage = () => {
    return <Outlet />;
}

export default StaffManagementMainPage;